<template>
<div class="participate thumbnail">
	<info-board :budget="availableBudget"
	            :showAlert="showAlert"
	            @save-design="openModal">
	</info-board>

	<pixi-stage style="width: 100%;"
	            @dropped="setSelected"
	            ref="pixiStage">

		<pixi-boundries :width="this.playfieldWidth" :height="this.playfieldHeight">
		</pixi-boundries>

		<pixi-trash :image-url="trashUrl"
		            :scale="0.7"
		            :local-x="200"
		            :local-y="300">
		</pixi-trash>

		<playset-item v-for="playset in lockedPlaysets"
		              :key="playset.id + '-locked'"
		              :image-url="playset.image"
		              :scale="Number(playset.scale)"
		              :local-y="playset.position.y"
		              :local-x="playset.position.x"
		              :locked="true">
		</playset-item>

		<playset-item v-for="playset in selectedPlaysets"
		              :key="playset.id"
		              :image-url="playset.image"
		              :scale="Number(playset.scale)"
		              :local-y="playset.position.y"
		              :local-x="playset.position.x"
		              @collision="onCollision(playset)"
		              @destroy="onDestroy(playset)">
		</playset-item>

	</pixi-stage>

	<playset-image-slider :playsets="availablePlaysets"
	                      :available-budget="availableBudget"></playset-image-slider>

	<div class="back-btn">
		<a href="/projects">
			<i class="fas fa-arrow-circle-left i-styles"></i>  Terug
		</a>
	</div>

	<submit-modal ref="modal"
	              :csrf-token-name="csrfTokenName"
	              :csrf-hash="csrfHash"
	              :project-id="projectId"
	              :image="image"
	              :expense="expense"
	              :selected-playsets="selectedPlaysets"></submit-modal>

</div>
</template>
<script>
// Import Vue Components
import PixiStage from './pixi-stage';
import PixiTrash from './pixi-trash';
import PixiBoundries from './pixi-boundries';
import PlaysetItem from './playset-item';
import InfoBoard from './info-board';
import PlaysetImage from './playset-image';
import ApiService from './api-service';
import SubmitModal from './submit-modal';
import PlaysetImageSlider from './playset-image-slider';

import { polyfill } from 'mobile-drag-drop';
import { scrollBehaviourDragImageTranslateOverride } from 'mobile-drag-drop/scroll-behaviour';
import { API_URL } from './constants';

const apiService = new ApiService(API_URL);

/* Enable Polyfill for dragging on mobile devices */
polyfill({
    // use this to make use of the scroll behaviour
    dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride
});

// add eventlisterer to prevent ios scroll
window.addEventListener( 'touchmove', function() {});

export default {
	name: 'ParticipateApp',
	components: {
		PixiStage,
		PixiBoundries,
		PixiTrash,
		PlaysetItem,
		InfoBoard,
		PlaysetImageSlider,
		SubmitModal,
	},
	computed: {
		availableBudget() {
			const playsetsTotal = this.selectedPlaysets
				.map(playset => Number(playset.price))
				.reduce((acc, current) => acc + current, 0);

			return (this.budget - playsetsTotal);
		},
		expense() {
			return this.budget - this.availableBudget;
		},
		selectedPlaysets() {
			return this.playsets.filter(playset => playset.selected === true);
		},
		availablePlaysets() {
			return this.playsets
				.filter(playset => (!playset.selected))
				.sort((x, y) => x.price > y.price);
		}
	},
	props: {
		projectId: {
			required: true,
			type: Number
		},
		csrfTokenName: {
			type: String,
			required: true
		},
		csrfHash: {
			type: String,
			required: true
		}
	},
	data: () => ({
		budget: 0,
		playsets: [],
		lockedPlaysets: [],
		playfieldWidth: 0,
		playfieldHeight: 0,
		image: null,
		showModal: false,
		alertTimeout: null,
		showAlert: false,
		trashUrl: `${document.cms_base_url}/assets/img/trash-bin.png`
	}),
	methods: {
		setSelected(selected) {

			const playsetIndex = this.playsets.findIndex(playset => playset.id == selected.id);

			this.$set(this.playsets, playsetIndex, Object.assign({}, this.playsets[playsetIndex], {
				position: selected.position,
				selected: true
			}));

		},

		onCollision(playset) {

			if (this.alertTimeout) {
				clearTimeout(this.alertTimeout);
			}

			playset.selected = false;
			this.showAlert = true;
			this.alertTimeout = setTimeout(() => this.showAlert = false, 1500);

		},

		onDestroy(playset) {
			playset.selected = false;
		},

		getProject() {

			apiService.getProject(this.projectId)
				.then(project => {
					this.budget = Number(project.budget);

					if (project.playfield_width && Number(project.playfield_width) > 0) {
						this.playfieldWidth = Number(project.playfield_width);
					} else {
						this.playfieldWidth = 1400;
					}

					if (project.playfield_height && Number(project.playfield_height) > 0) {
						this.playfieldHeight = Number(project.playfield_height);
					} else {
						this.playfieldHeight = 565;
					}

					try {
						this.lockedPlaysets = JSON.parse(project.initial_playsets);
					} catch (error) {
						this.lockedPlaysets = [];
					}

					return this.getPlaysets();
				})
				.catch(error => console.error('Error while requesting project'));

		},

		getPlaysets() {

			apiService.getPlaysets(this.projectId)
				.then(playsets =>
					this.playsets = playsets.map(playset =>
						Object.assign({}, playset, {
							id: Number(playset.id),
							image: `${document.cms_base_url}/${playset.image}`,
							price: Number(playset.price)
						})
					)
				)
				.catch(error => console.error('Error while requesting playsets'));

		},

		openModal() {
			this.image = this.$refs.pixiStage.getImage();
			this.$refs.modal.openModal();
		}
	},
	mounted() {
		this.getProject();
	}
}
</script>
<style lang="scss" scoped>
i {
    border: solid #fff;
    border-width: 0 10px 10px 0;
    display: inline-block;
    padding: 10px;
}
.back-btn {
    background-color: #e7e7e7;
    padding: 5px 20px;
    box-shadow: -1px 1px 3px rgba(0, 0, 0, 0.10);
    display: inline-block;
}
.back-btn:hover {
    background-color: #f5f5fa;
    text-decoration: none;
    opacity: 1;
    transition: ease 0.5s;
}
a {
    color: #727272;
}
.i-styles {
    color: #727272;
}
.thumbnail {
    padding: 10px;
}

.pixi-wrapper {
    margin-top: -60px;
}
</style>



// WEBPACK FOOTER //
// assets/vue/apps/participate/participate-app.vue